import React, { useState, useRef, useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Menu from 'components/Menu';
import { FormTitle, VcEGrid, VcGrid } from 'components/Grid';

import { TableColumn } from 'components/NewTable/type';
import DateOneSePickersTyping from 'components/DatePicker/DateOneSePickersTyping';

import { isType, localeTw, userTypeList } from 'main_consts';
import { Iobject, Ioption } from 'main_type';
import {
  blobDownload,
  getSample,
  postSearch,
  snackBarRsp,
  confirm,
  deleteItem,
  upload,
  postExcel,
} from 'main_api';

import { AgGridReact } from 'ag-grid-react';
import { ColDef, GridOptions } from 'ag-grid-community';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Alert from '@material-ui/lab/Alert';
import SearchIcon from '@material-ui/icons/Search';
import PrintIcon from '@material-ui/icons/Print';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import ClearIcon from '@material-ui/icons/Clear';
import RefreshIcon from '@material-ui/icons/Refresh';

import { useSnackbar } from 'notistack';
import { setLoadingRedux } from 'reducers/shareData/action';
import {
  getUserInfoRedux,
  getWareHouseListRedux,
} from 'reducers/shareData/selector';
import Select from 'components/Material/Select';
import DateSePickersTyping from 'components/DatePicker/DateSePickersTyping';
import CheckBox from 'components/Material/Checkbox';
import Input from 'components/Material/Input';
import WarehouseModal from 'components/Modal/WareHouseModal';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Header from 'components/Header';
import {
  checkboxChange,
  formatDate,
  getDateDayPlus,
  getWarehouse,
  initWhrehhouse,
  inputChange,
  selectChange,
} from '../../../main_func';

import { Iresult, Imaster, ICRUDDetail, ICRUD } from './type';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        margin: theme.spacing(1),
      },
    },
    input: {
      display: 'none',
    },
  })
);
/** 儲區基本資料維護 */
const StorageAreaMtn = (): JSX.Element => {
  const classes = useStyles();
  const warehouseRedux = useSelector(getWareHouseListRedux);
  const { user, userType, locationCode } = useSelector(getUserInfoRedux);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [formError, setFormError] = useState(false);
  const [submitKey, setSubmitKey] = useState('search');
  const apiName = 'storageAreaMtn';
  const [rowData, setRowData] = useState<Iresult[]>([]);
  const [openSearchTable, setOpenSearchTable] = useState(false);
  const [randomValue, setRandomValue] = useState(Math.random());
  const [warehouseName, setWarehouseName] = useState('');

  const [storageAreaOptions, setStorageAreaOptions] = useState<Ioption[]>([]);
  const [enableSave, setEnableSave] = useState<boolean>(false);

  const masterDefaultValue: Imaster = {
    // 儲區名稱
    storageAreaDesc: '',
    storageAreaId: '',
    chkCode1: '',
    warehouse:
      userType === userTypeList.type1[0] || userType === userTypeList.type2[0]
        ? initWhrehhouse(userType, warehouseRedux, locationCode)
        : 'TPEE011S',

    pageSize: 100,
  };
  const [master, setMaster] = useState(masterDefaultValue);
  const [random, setRamdom] = useState(Math.random());

  useEffect(() => {
    if (
      userType &&
      !(
        isType(userTypeList.admin, userType) ||
        isType(userTypeList.type1, userType)
      )
    ) {
      setFormError(true);
      enqueueSnackbar(`您無權限使用此功能!`);
    }
    setMaster((prev) => ({
      ...prev,
      warehouse: masterDefaultValue.warehouse,
    }));
  }, [userType]);

  const gridRef = useRef<any>(undefined);
  const getColumnDefs = (status: boolean): ColDef[] => {
    return [
      {
        checkboxSelection: true,
        lockPosition: true,
        headerName: '項次',
        field: 'itemNo',
        valueGetter: 'node.rowIndex',
        cellClass: 'locked-col',
        suppressNavigable: true,
        maxWidth: 100,
        filter: false,
        sortable: false,
        editable: false,
        valueFormatter: (data) => {
          return data.value + 1;
        },
      },
      {
        headerName: '儲區名稱',
        field: 'storageAreaDesc',
        width: 300,
        editable: true,
      },
      {
        headerName: '修改時間',
        field: 'updTime',
        width: 300,
      },
      {
        headerName: '修改人員',
        field: 'userId',
        width: 300,
      },
      {
        headerName: '處理說明',
        field: 'processDesc',
        minWidth: 250,
        cellStyle: (params) => {
          if (params && params.data.processDesc === '寫檔成功!') {
            return { fontWeight: 'initial', color: 'black' };
          }
          return { fontWeight: 'bold', color: 'red' };
        },
      },
    ];
  };
  const gridOptions = useMemo<GridOptions>(() => {
    const colDefs: ColDef[] = getColumnDefs(false);

    const options: GridOptions = {
      columnDefs: colDefs,
      defaultColDef: {
        flex: 1,
        minWidth: 120,
        filter: true,
        resizable: true,
        sortable: true,
        editable: false,
      },
      frameworkComponents: {},
      components: {},
      tooltipShowDelay: 1,
      headerHeight: 40,
      rowHeight: 40,
      animateRows: true,
      rowSelection: 'multiple',
      suppressRowClickSelection: true,
      multiSortKey: 'ctrl',
      localeText: localeTw,
      pagination: true,
      paginationPageSize: 100,
    };

    return options;
  }, []);

  const onGridReady = (params: any) => {
    params.api.sizeColumnsToFit();
  };
  const handleSearch = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));

    const result = await postSearch(apiName, {
      warehouse: master.warehouse,
      storageAreaDesc: master.storageAreaDesc,
    });
    dispatch(setLoadingRedux(false));
    if (!snackBarRsp(enqueueSnackbar, result)) {
      return;
    }

    // TODO 確認List名稱
    const { data: dataTemp } = result.data;
    const { enableSave: enableSaveTemp, storageAreaMtnDTOs: rowDetailsTemp } =
      (dataTemp as {
        enableSave: boolean;
        storageAreaMtnDTOs: unknown | unknown[];
      }) || {};
    const data = rowDetailsTemp as Iresult[];
    if (data && (data || []).length > 0) {
      setEnableSave(enableSaveTemp);
      setRowData(data);
      setOpenSearchTable(true);
    } else {
      setEnableSave(false);
      setOpenSearchTable(false);
    }
    setRandomValue(Math.random());
  };

  const handleConfirm = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));

    await gridRef.current.api.stopEditing(false);

    const rowDataCRUD: ICRUDDetail[] = [];

    const selectedDatas = gridRef.current.api.getSelectedNodes();
    if (selectedDatas && selectedDatas.length > 0) {
      selectedDatas.forEach((node: any) => {
        const itemDataCRUD: ICRUDDetail = {
          rownum: node.data.rownum,
          warehouse: node.data.warehouse,
          storageAreaDesc: node.data.storageAreaDesc,
          storageAreaId: node.data.storageAreaId,
        };
        dispatch(setLoadingRedux(false));
        return rowDataCRUD.push(itemDataCRUD);
      });
    } else {
      dispatch(setLoadingRedux(false));
      enqueueSnackbar('請先選擇資料');
      return;
    }
    const DataCRUD: ICRUD = {
      storageAreaMtnDTOs: rowDataCRUD,
      warehouse: master.warehouse,
      storageAreaDesc: master.storageAreaDesc,
      storageAreaId: master.storageAreaId,
    };

    const result = await confirm(apiName, DataCRUD);

    dispatch(setLoadingRedux(false));
    if (!snackBarRsp(enqueueSnackbar, result)) {
      return;
    }
    const { data: dataTemp } = result.data;

    const { enableSave: enableSaveTemp, storageAreaMtnDTOs: rowDetailsTemp } =
      (dataTemp as {
        enableSave: boolean;
        storageAreaMtnDTOs: unknown | unknown[];
      }) || {};
    const data = rowDetailsTemp as Iresult[];

    if ((data || []).length > 0) {
      setEnableSave(enableSaveTemp);

      setRowData(data);
      setOpenSearchTable(true);
    } else {
      setEnableSave(false);
      setOpenSearchTable(false);
    }
    setRandomValue(Math.random());
  };

  const handleDeleteItem = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));

    await gridRef.current.api.stopEditing(false);

    const rowDataCRUD: ICRUDDetail[] = [];

    const selectedDatas = gridRef.current.api.getSelectedNodes();
    if (selectedDatas && selectedDatas.length > 0) {
      selectedDatas.forEach((node: any) => {
        const itemDataCRUD: ICRUDDetail = {
          rownum: node.data.rownum,
          storageAreaId: node.data.storageAreaId,
          storageAreaDesc: node.data.storageAreaDesc,
          warehouse: node.data.warehouse,
        };
        return rowDataCRUD.push(itemDataCRUD);
      });
    } else {
      enqueueSnackbar('請先選擇資料');
      return;
    }

    const DataCRUD: ICRUD = {
      storageAreaMtnDTOs: rowDataCRUD,
      storageAreaDesc: master.storageAreaDesc,
      storageAreaId: master.storageAreaId,
      warehouse: master.warehouse,
    };
    const result = await deleteItem(apiName, DataCRUD);
    dispatch(setLoadingRedux(false));
    if (!snackBarRsp(enqueueSnackbar, result)) {
      return;
    }

    const { data: dataTemp } = result.data;

    const { enableSave: enableSaveTemp, storageAreaMtnDTOs: rowDetailsTemp } =
      (dataTemp as {
        enableSave: boolean;
        storageAreaMtnDTOs: unknown | unknown[];
      }) || {};
    const data = rowDetailsTemp as Iresult[];

    if ((data || []).length > 0) {
      setEnableSave(enableSaveTemp);

      setRowData(data);
      setOpenSearchTable(true);
    } else {
      setEnableSave(false);
      setOpenSearchTable(false);
    }
    setRandomValue(Math.random());
  };

  const handleUpload = async (
    file: File,
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));
    await gridRef.current?.api.stopEditing(true);

    const formData = new FormData();
    formData.append('execlFile', file);

    const result = await upload(apiName, formData);

    dispatch(setLoadingRedux(false));
    if (!snackBarRsp(enqueueSnackbar, result)) {
      return;
    }

    const { data: dataTemp } = result.data;

    const { enableSave: enableSaveTemp, storageAreaMtnDTOs: rowDetailsTemp } =
      (dataTemp as {
        enableSave: boolean;
        storageAreaMtnDTOs: unknown | unknown[];
      }) || {};
    const data = rowDetailsTemp as Iresult[];

    if ((data || []).length > 0) {
      setEnableSave(enableSaveTemp);

      setRowData(data);
      setOpenSearchTable(true);
    } else {
      setEnableSave(false);
      setOpenSearchTable(false);
    }
    setRandomValue(Math.random());
  };
  const selectFile = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = (e.target as HTMLInputElement).files?.item(0); // 取得選中檔案們的一個檔案

    if (file) {
      handleUpload(file);
    }
    e.target.value = '';
  };

  const handleDownload = async (e?: React.FormEvent<HTMLFormElement>) => {
    try {
      if (e && e.preventDefault) {
        e.preventDefault();
      }
      dispatch(setLoadingRedux(true));
      await gridRef.current?.api.stopEditing(true);

      const result = await postExcel(apiName, {
        storageAreaDesc: master.storageAreaDesc,
        storageAreaId: master.storageAreaId,
        warehouse: master.warehouse,
      });

      blobDownload(result, enqueueSnackbar, `${master.warehouse}_儲區.xlsx`);
      dispatch(setLoadingRedux(false));
    } catch (error) {
      dispatch(setLoadingRedux(false));
    }
  };

  const handleSubmit = (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    switch (submitKey) {
      case 'search':
        handleSearch();
        break;
      case 'confirm':
        handleConfirm();
        break;
      case 'deleteItem':
        handleDeleteItem();
        break;
      case 'getExcel':
        handleDownload();
        break;
      default:
        break;
    }
  };

  const updateData = async (updateObj: Iobject) => {
    setMaster({ ...master, ...updateObj });
    const key: string[] = Object.keys(updateObj);
  };

  const selectPage = async () => {
    if (gridRef.current) {
      const setRangeSelected = async (
        firstIndex: number,
        lastIndex: number
      ) => {
        let index = lastIndex;
        let index2 = lastIndex;
        let index3 = firstIndex;

        const maxIndex: number =
          gridRef.current.api.paginationGetRowCount() as number;
        if (lastIndex > maxIndex) {
          index2 = maxIndex;
        }
        index3 = 0;

        for (index = index3; index < index2; index += 1) {
          const rowNode = gridRef.current.api.getDisplayedRowAtIndex(index);
          if (rowNode) {
            rowNode.setSelected(true, false);
          }
        }
      };
      // 取得當前頁數第一筆
      const firstIdx =
        gridRef.current.api.paginationGetCurrentPage() *
        gridRef.current.api.paginationGetPageSize();
      // 取得當前頁數最後一筆
      const lastIdx: number =
        firstIdx + gridRef.current.api.paginationGetPageSize();
      // 設定範圍選取
      setRangeSelected(firstIdx, lastIdx);
    }
  };

  const selectNoPage = async () => {
    // gridRef.current!.api.forEachNode((node: any, index: number) =>
    //   node.setSelected(!!node.data && node.data.year !== 2012)
    // );
    // let lastIndex: number;
    // let maxIndex :number;
    if (gridRef.current) {
      const setRangeSelected = async (
        firstIndex: number,
        lastIndex: number
      ) => {
        let index = lastIndex;
        let index2 = lastIndex;
        let index3 = firstIndex;

        const maxIndex: number =
          gridRef.current.api.paginationGetRowCount() as number;
        if (lastIndex > maxIndex) {
          index2 = maxIndex;
        }
        index3 = 0;

        for (index = index3; index < index2; index += 1) {
          const rowNode = gridRef.current.api.getDisplayedRowAtIndex(index);
          if (rowNode) {
            rowNode.setSelected(false, false);
          }
        }
      };
      // 取得當前頁數第一筆
      const firstIdx =
        gridRef.current.api.paginationGetCurrentPage() *
        gridRef.current.api.paginationGetPageSize();
      // 取得當前頁數最後一筆
      const lastIdx: number =
        firstIdx + gridRef.current.api.paginationGetPageSize();
      // 設定範圍選取
      setRangeSelected(firstIdx, lastIdx);
    }
  };

  const handleReset = async () => {
    setRamdom(Math.random());
    setMaster(masterDefaultValue);
    setOpenSearchTable(false);
    setFormError(false);
    setRandomValue(Math.random());
    setEnableSave(false);
  };
  return (
    <div id="page-area">
      <Header />
      <form onSubmit={handleSubmit} className="form-area">
        <div>
          <div className="title">
            <EditIcon /> 儲區基本資料維護
          </div>
        </div>
        <div className="input-area">
          {userType && isType(userTypeList.admin, userType) && (
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                <FormTitle>
                  {[...userTypeList.type2, ...userTypeList.type1].indexOf(
                    userType
                  ) !== -1
                    ? '*'
                    : ''}
                  快遞倉站：
                </FormTitle>
              </VcEGrid>
              <VcGrid item xs={12} sm={3}>
                <WarehouseModal
                  value={master.warehouse}
                  updateData={updateData}
                  setStatus={setWarehouseName}
                />
              </VcGrid>

              <VcGrid item xs={12} sm={3}>
                {warehouseName && (
                  <Alert
                    severity="info"
                    style={{
                      width: '100%',
                      color: 'red',
                      margin: '0 0.5rem',
                      fontSize: '1em',
                    }}
                    icon={false}
                  >
                    {warehouseName}
                  </Alert>
                )}
              </VcGrid>
            </Grid>
          )}
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>儲區名稱：</FormTitle>
            </VcEGrid>
            <Grid item xs={12} sm={2}>
              <Input
                maxLength={35}
                value={master.storageAreaDesc}
                name="storageAreaDesc"
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
              />
            </Grid>
          </Grid>
        </div>
        <Grid container className="button-area">
          <VcEGrid item xs={12} sm={2}>
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SearchIcon />}
              onClick={() => setSubmitKey('search')}
            >
              查詢
            </Button>
          </VcEGrid>

          <Grid item xs={12} sm="auto">
            <Button
              disabled={
                userTypeList.type4.some((v) => v === userType) &&
                locationCode.trim().length === 0
              }
              variant="outlined"
              color="primary"
              startIcon={<RefreshIcon />}
              onClick={() => handleReset()}
            >
              重置
            </Button>
          </Grid>
          <VcEGrid item xs={12} sm="auto">
            <Button
              disabled={!enableSave || formError}
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
              onClick={() => setSubmitKey('confirm')}
            >
              確定
            </Button>
          </VcEGrid>
          <VcEGrid item xs={12} sm="auto">
            <Button
              disabled={!enableSave || formError}
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
              onClick={() => setSubmitKey('deleteItem')}
            >
              刪除
            </Button>
          </VcEGrid>

          <Grid item xs={12} sm="auto">
            <input
              disabled={formError}
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              className={classes.input}
              id="contained-button-file"
              // multiple
              type="file"
              onChange={selectFile}
            />
            <label htmlFor="contained-button-file">
              <Button
                disabled={formError}
                variant="contained"
                color="default"
                startIcon={<AttachFileIcon />}
                component="span"
                style={{
                  borderRadius: '20px',
                  // backgroundColor: 'blue',
                }}
              >
                上傳EXCEL
              </Button>
            </label>
          </Grid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="default"
              startIcon={<PrintIcon />}
              onClick={() => setSubmitKey('getExcel')}
            >
              下載EXCEL
            </Button>
          </Grid>

          {/* <Grid item xs={12} sm="auto">
            <Button
              type="submit"
              variant="outlined"
              color="primary"
              startIcon={<SaveIcon />}
              onClick={() => setSubmitKey('getSample')}
            >
              下載EXCEL格式範本
            </Button>
          </Grid> */}
        </Grid>
      </form>

      {openSearchTable && (
        <Grid container>
          <VcEGrid>
            <Button
              className="button-DutyNoQryDld"
              type="submit"
              onClick={selectPage}
              variant="contained"
              color="default"
              startIcon={
                <DoneAllIcon
                  style={{
                    borderRadius: '30px',
                  }}
                />
              }
            >
              全選
            </Button>
          </VcEGrid>
          <Grid item xs={12} sm="auto">
            <Button
              className="button-DutyNoQryDld"
              type="submit"
              onClick={selectNoPage}
              variant="contained"
              color="default"
              startIcon={<ClearIcon />}
            >
              全不選
            </Button>
          </Grid>
        </Grid>
      )}
      {openSearchTable && (
        <div className="ag-theme-alpine" style={{ height: '500px' }}>
          <AgGridReact
            ref={gridRef}
            rowData={rowData}
            gridOptions={gridOptions}
            onGridReady={onGridReady}
          />
        </div>
      )}
    </div>
  );
};

export default StorageAreaMtn;
